<template>
    <div class="zhiji-service-page" id="zhiji-service-page">
        <router-view v-if="isInited"></router-view>
        <Modal />
    </div>
</template>

<script>
import Modal from "@/views/zhiji/components/modals/Modal";
import { setInitPromise } from "@/views/zhiji/js/services/service.js";
import { initedPromise } from "@/lib/auth";

export default {
    name: "ServicePage",
    components: {
        Modal
    },
    data() {
        return {
            isInited: false
        };
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.zhiji.services[propName];
        }
    },
    created() {
        // 定义初始化完成操作
        setInitPromise(
            initedPromise.then(() => {
                // 判断内容库是否在当前业务内容库列表里
                const robots = this.$store.state.auth.businessSetting.robots || [];
                const gameId = this.$store.state.zhiji.gameState.gameId;
                const isInRobots = robots.some(robot => {
                    return robot.gameId == gameId;
                });

                if (!isInRobots && robots.length) {
                    // 不是当前业务的内容库，切换成当前内容库列表的第一个
                    this.$store.commit("zhiji/switchGameId", robots[0].gameId);
                } else if (!isInRobots) {
                    this.$store.commit("zhiji/switchGameId", -1);
                }

                this.$store.commit("zhiji/setRobots", robots); // 设置当前业务内容库列表

                this.isInited = true;
            })
        );
    }
};
</script>

<style lang="less">
#zhiji-service-page {
    width: 100%;
    height: 100%;
    overflow: auto;
}

.zhiji-service-page {
    div,
    dl,
    dt,
    dd,
    ul,
    ol,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    pre,
    code,
    form,
    fieldset,
    legend,
    input,
    textarea,
    p,
    blockquote,
    th,
    td,
    hr,
    button,
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
        margin: 0;
    }
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
        display: block;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    audio,
    canvas,
    video {
        display: inline-block;
        *display: inline;
        *zoom: 1;
    }
    fieldset,
    img {
        border: 0;
    }
    address,
    caption,
    cite,
    code,
    dfn,
    em,
    strong,
    th,
    var {
        font-style: normal;
        font-weight: normal;
    }
    ol,
    ul {
        list-style: none;
        padding: 0;
    }
    caption,
    th {
        text-align: left;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: 100%;
        font-weight: normal;
    }
    q:before,
    q:after {
        content: "";
    }
    abbr,
    acronym {
        border: 0;
        font-variant: normal;
    }
    sup {
        vertical-align: text-top;
    }
    sub {
        vertical-align: text-bottom;
    }
    input,
    textarea,
    keygen,
    select,
    button {
        font-family: "Microsoft YaHei", "PingFangSC-Regular", "sans-serif";
        font-size: inherit;
        font-weight: inherit;
        font-size: 12px;
    }
    input,
    textarea,
    select {
        *font-size: 100%;
    }
    a {
        text-decoration: none;
    }
    img {
        vertical-align: top;
    }
    input::-ms-clear {
        display: none;
    }
    input::-ms-reveal {
        display: none;
    }
    body {
        position: relative;
        font: 14px/1.5 "Microsoft YaHei", tahoma, sans-serif;
        color: #333;
    }
    input,
    textarea {
        color: #41475e;
        outline: none;
        border: none;
        box-sizing: border-box;
    }
    input::placeholder,
    textarea::placeholder {
        color: #9b9ba3;
    }
    input:focus::placeholder,
    textarea:focus::placeholder {
        color: #c9c9c9;
    }
    .fl {
        float: left;
    }
    .fr {
        float: right;
    }
    textarea {
        resize: none;
    }
}
</style>
